<template>
    <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
        <div v-if="this.isMobile">
            <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
            {{ this.$t('components.service.modal.InvoicesFilter.1') }}
        </div>
        <div v-if="!this.isMobile">
            <Icon name="close" class="c24 pointer" @click="this.close()"/>
        </div>
    </div>
    <div class="text-black bg-white rounded12" :class="{ 'p-0': this.isMobile, 'p24': !this.isMobile }">
        <div class="mb16">
            <label class="fsp14 lh20 text-black mb8">{{ $t('components.service.modal.InvoicesFilter.2') }}</label>
            <SelectSimple
                id="status"
                :defaultValue="this.$t('components.service.modal.InvoicesFilter.7')"
                :keywords.sync="this.statusList"
                :toggleIcons="true"
                :iconName="'info'"
                :isFilterSelect="true"
                :hotUpdate="true"
                :dataValue="this.fields.status" 
                @updateParentState="this.updateState"
            />
        </div>
        <div class="mb16">
            <label class="fsp14 lh20 text-black mb8">{{ $t('components.service.modal.InvoicesFilter.3') }}</label>
            <SelectMulti
                id="shop"
                :keywords.sync="this.shopList"
                :hotUpdate="true"
                :icon="'eshop'"
                :defaultValue="this.$t('components.service.modal.InvoicesFilter.8')"
                :dataValue="this.fields.shop"
                @updateParentState="this.updateState"
            />
        </div>
        <div class="mb16">
            <div class="d-flex align-items-center justify-content-between">
                <div class="fsp14 lh20 text-black mb8">
                    {{ $t('components.service.modal.InvoicesFilter.4') }}
                </div>
                <div class="menu-bg fsp14 lh20 neue pointer text-decoration-underline" 
                    @click="this.fields.keyt_shop = false"
                    >
                    {{ $t('components.service.modal.HistoryFilter.21') }}
                </div>
            </div>
            <SelectSimple
                id="keyt_shop"
                :keyt="true"
                :isSearch="true"
                :keywords.sync='this.$store.getters.get_keyts_keywords'
                :hotUpdate="true"
                :dataValue="this.fields.keyt_shop"
                @updateParentState="this.updateState"
            />
        </div>
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">{{ $t('views.Merchant.Invoices.20') }}</label>
            <InputSimple
                id="code"
                :icon="'receipt-text'"
                :placeholder="this.$t('components.service.modal.InvoicesFilter.9')"
                :dataValue="this.fields.code"
                :regCheck="{ f: (value) => value.replace(/\D/g, '') }"
                @updateParentState="this.updateState"
            />
        </div>
        <div class="d-flex align-items-center w-100" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
            <Button type="btn-warning" class="equal-width h48 mr16" @click="this.save()">{{ $t('components.service.modal.InvoicesFilter.5') }}</Button>
            <Button type="btn-outline-grey" class="equal-width h48 primary-grey" @click="this.clearAll()">{{ $t('components.service.modal.InvoicesFilter.6') }}</Button>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon.vue';   
import Button from '@/components/service/Button.vue';
import SelectSimple from '@/components/service/SelectSimple.vue';
import InputSimple from '@/components/service/InputSimple.vue';
import SelectMulti from '@/components/service/SelectMulti.vue';

export default {
    name: 'InvoicesFilter',
    components: {
        Icon,
        Button,
        SelectSimple,
        InputSimple,
        SelectMulti
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            fields: {
                status: '',
                shop: '',
                keyt_shop: '',
                code: ''
            },
            statusList: [
                {
                    code: 'cancelled',
                    value: this.$t('views.Merchant.Invoices.22')
                },
                {
                    code: 'paid',
                    value: this.$t('views.Merchant.Invoices.23')
                },
                {
                    code: 'expired',
                    value: this.$t('views.Merchant.Invoices.24')
                },
                {
                    code: 'created',
                    value: this.$t('views.Merchant.Invoices.25')
                },
                {
                    code: 'failed',
                    value: this.$t('views.Merchant.Invoices.26')
                },
                {
                    code: 'paused',
                    value: this.$t('views.Merchant.Invoices.27')
                },
                {
                    code: 'returned',
                    value: this.$t('views.Merchant.Invoices.28')
                }
            ],
            shopList: []
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        updateState(state) {
            console.log(state);
            this.fields[state.id] = state.value;
        },
        save() {
            this.callback(this.fields);
            this.close();
        },
        clearAll() {
            this.fields.status = '';
            this.fields.shop = '';
            this.fields.keyt_shop = '';
            this.fields.code = '';
        }
    },
    created() {
        this.callback = this.$store.state.modal.content.callback;
        this.fields.status = this.$store.state.modal.content.fields.status;
        this.fields.shop = this.$store.state.modal.content.fields.shop;
        this.fields.keyt_shop = this.$store.state.modal.content.fields.keyt_shop;
        this.fields.code = this.$store.state.modal.content.fields.code;
        this.shopList = this.$store.state.modal.content.shopList;
    }
}
</script>